// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mortgage-dashboard-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.mortgage-dashboard-container .contents {
  margin-top: 60px;
  max-height: calc(100vh - 140px);
}
.mortgage-dashboard-container .contents p {
  margin: 0;
}
.mortgage-dashboard-container .contents .showings-today-container {
  height: calc(100vh - 309px);
}
.mortgage-dashboard-container .contents .block {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.mortgage-dashboard-container .contents .block .data > div {
  flex: 1 1;
}
.mortgage-dashboard-container .contents .connection-list {
  height: calc(100vh - 290px);
}
.mortgage-dashboard-container .contents .connection-list .profile {
  display: flex;
  column-gap: 16px;
  align-items: center;
  width: 250px;
}
.mortgage-dashboard-container .contents .connection-list .profile > img {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 100%;
}
.mortgage-dashboard-container .contents .connection-list .profile p {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}
.mortgage-dashboard-container .contents .view-all {
  font-size: 12px;
  font-weight: 700;
  color: #5F5F5F;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.mortgage-dashboard-container .contents .view-all:hover {
  opacity: 0.75;
}
.mortgage-dashboard-container .contents .divider.team-member {
  background: #88B7FF;
}
.mortgage-dashboard-container .contents .divider.listing-agent {
  background: var(--primary-color-1);
}
.mortgage-dashboard-container .contents .divider.buyer-agent {
  background: #9E3645;
}
.mortgage-dashboard-container .contents .divider.buyer-agent.listing-agent {
  background: linear-gradient(#9E3645 50%, var(--primary-color-1) 50%);
}
.mortgage-dashboard-container .contents .border-r {
  border-right: 1px solid #E4E4E4;
}
.mortgage-dashboard-container .contents .border-b {
  border-bottom: 1px solid #E4E4E4;
}
.mortgage-dashboard-container .contents .border-rb {
  border-bottom: 1px solid #E4E4E4;
  border-right: 1px solid #E4E4E4;
}
.mortgage-dashboard-container .contents .header {
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: var(--secondary-color-1);
}
.mortgage-dashboard-container .contents .link {
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.mortgage-dashboard-container .contents .link:hover {
  opacity: 0.75;
}
.mortgage-dashboard-container .contents .subheader {
  font-size: 12px;
  color: #5F5F5F;
  font-weight: 600;
}
.mortgage-dashboard-container .contents .title {
  color: #949494;
  font-weight: 500;
  font-size: 12px;
}
.mortgage-dashboard-container .contents .data {
  font-weight: 400;
  font-size: 24px;
  color: var(--secondary-color-1);
}
.mortgage-dashboard-container .contents .list {
  animation: fadein 0.5s;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .mortgage-dashboard-container .contents .block {
    max-width: none !important;
  }
  .mortgage-dashboard-container .contents .block .data {
    flex-wrap: nowrap;
  }
  .mortgage-dashboard-container .contents .block .data > div {
    flex: none;
  }
  .mortgage-dashboard-container .contents .block .list {
    row-gap: 30px;
  }
  .mortgage-dashboard-container .contents .block .list > li {
    flex-wrap: wrap-reverse;
    row-gap: 8px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .mortgage-dashboard-container .contents .block {
    max-width: none !important;
  }
  .mortgage-dashboard-container .contents .block .data {
    flex-wrap: nowrap;
  }
  .mortgage-dashboard-container .contents .block .data > div {
    flex: none;
  }
  .mortgage-dashboard-container .contents .block .list {
    row-gap: 30px;
  }
  .mortgage-dashboard-container .contents .block .list > li {
    flex-wrap: wrap-reverse;
    row-gap: 8px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .mortgage-dashboard-container .contents > div {
    flex-direction: column;
  }
  .mortgage-dashboard-container .contents .showings-today-container {
    height: 100%;
  }
  .mortgage-dashboard-container .contents .block {
    max-width: none !important;
  }
  .mortgage-dashboard-container .contents .connection-list .profile {
    width: auto;
    flex: 1 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/MortgageDashboard/modules/MortgageDashboard/dashboard.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;AADJ;AAGI;EACI,gBAAA;EACA,+BAAA;AADR;AAGQ;EACI,SAAA;AADZ;AAIQ;EACI,2BAAA;AAFZ;AAKQ;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAHZ;AAMgB;EACI,SAAA;AAJpB;AAQQ;EACI,2BAAA;AANZ;AAOY;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AALhB;AAMgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAJpB;AAMgB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AAJpB;AASQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;AAPZ;AASY;EACI,aAAA;AAPhB;AAYY;EACI,mBAAA;AAVhB;AAaY;EACI,kCAAA;AAXhB;AAcY;EAKI,mBAAA;AAhBhB;AAYgB;EACI,oEAAA;AAVpB;AAiBQ;EACI,+BAAA;AAfZ;AAkBQ;EACI,gCAAA;AAhBZ;AAmBQ;EACI,gCAAA;EACA,+BAAA;AAjBZ;AAoBQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AAlBZ;AAqBQ;EACI,eAAA;EACA,4BAAA;AAnBZ;AAqBY;EACI,aAAA;AAnBhB;AAuBQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AArBZ;AAwBQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAtBZ;AAyBQ;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;AAvBZ;AA0BQ;EACI,sBAAA;AAxBZ;AA4BI;EACI;IACI,UAAA;EA1BV;EA6BM;IACI,UAAA;EA3BV;AACF;;ACzGY;ED2IA;IACI,0BAAA;EA9Bd;EAgCc;IACI,iBAAA;EA9BlB;EAgCkB;IACI,UAAA;EA9BtB;EAkCc;IACI,aAAA;EAhClB;EAkCkB;IACI,uBAAA;IACA,YAAA;EAhCtB;AACF;ACnIY;EDkJA;IACI,0BAAA;EAZd;EAcc;IACI,iBAAA;EAZlB;EAckB;IACI,UAAA;EAZtB;EAgBc;IACI,aAAA;EAdlB;EAgBkB;IACI,uBAAA;IACA,YAAA;EAdtB;AACF;ACrJY;ED6KA;IACI,sBAAA;EArBd;EAwBU;IACI,YAAA;EAtBd;EAyBU;IACI,0BAAA;EAvBd;EA0Bc;IACI,WAAA;IACA,SAAA;EAxBlB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.mortgage-dashboard-container {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    font-family: \"Proxima Nova\", sans-serif;\n\n    .contents {\n        margin-top: 60px;\n        max-height: calc(100vh - 140px);\n\n        p {\n            margin: 0;\n        }\n\n        .showings-today-container {\n            height: calc(100vh - 309px);\n        }\n\n        .block {\n            padding: 24px;\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n\n            .data {\n                >div {\n                    flex: 1;\n                }\n            }\n        }\n        .connection-list {\n            height: calc(100vh - 290px);\n            .profile {\n                display: flex;\n                column-gap: 16px;\n                align-items: center;\n                width: 250px;\n                > img {\n                    width: 32px;\n                    height: 32px;\n                    object-fit: cover;\n                    border-radius: 100%;\n                }\n                p {\n                    margin: 0;\n                    font-size: 12px;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        .view-all {\n            font-size: 12px;\n            font-weight: 700;\n            color: #5F5F5F;\n            cursor: pointer;\n            transition: .2s ease-in-out;\n\n            &:hover {\n                opacity: .75;\n            }\n        }\n\n        .divider {\n            &.team-member {\n                background: #88B7FF;\n            }\n\n            &.listing-agent {\n                background: var(--primary-color-1);\n            }\n\n            &.buyer-agent {\n                &.listing-agent {\n                    background: linear-gradient(#9E3645 50%, var(--primary-color-1) 50%);\n                }\n\n                background: #9E3645;\n            }\n        }\n\n        .border-r {\n            border-right: 1px solid #E4E4E4;\n        }\n\n        .border-b {\n            border-bottom: 1px solid #E4E4E4;\n        }\n\n        .border-rb {\n            border-bottom: 1px solid #E4E4E4;\n            border-right: 1px solid #E4E4E4;\n        }\n\n        .header {\n            font-weight: 600;\n            font-size: 16px;\n            line-height: 16px;\n            color: var(--secondary-color-1);\n        }\n\n        .link {\n            cursor: pointer;\n            transition: .2s ease-in-out;\n\n            &:hover {\n                opacity: .75;\n            }\n        }\n\n        .subheader {\n            font-size: 12px;\n            color: #5F5F5F;\n            font-weight: 600;\n        }\n\n        .title {\n            color: #949494;\n            font-weight: 500;\n            font-size: 12px;\n        }\n\n        .data {\n            font-weight: 400;\n            font-size: 24px;\n            color: var(--secondary-color-1);\n        }\n\n        .list {\n            animation: fadein .5s;\n        }\n    }\n\n    @keyframes fadein {\n        from {\n            opacity: 0;\n        }\n\n        to {\n            opacity: 1;\n        }\n    }\n}\n\n@include media(tablet, mobile) {\n    .mortgage-dashboard-container {\n        .contents {\n            .block {\n                max-width: none !important;\n\n                .data {\n                    flex-wrap: nowrap;\n\n                    >div {\n                        flex: none;\n                    }\n                }\n\n                .list {\n                    row-gap: 30px;\n\n                    >li {\n                        flex-wrap: wrap-reverse;\n                        row-gap: 8px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .mortgage-dashboard-container {\n        .contents {\n            >div {\n                flex-direction: column;\n            }\n\n            .showings-today-container {\n                height: 100%;\n            }\n\n            .block {\n                max-width: none !important;\n            }\n            .connection-list {\n                .profile {\n                    width: auto;\n                    flex: 1;\n                }\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
